var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 9.867,
    viewBox: "0 0 16 9.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "keyboard_arrow_down_24dp_5F6368_FILL0_wght400_GRAD0_opsz24",
    d: "M248-630.133l-8-8L241.867-640,248-633.867,254.133-640,256-638.133Z",
    transform: "translate(-240 640)",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcons);
export default __webpack_public_path__ + "static/media/arrow_icons.c2b4b0dbd369f43fa4ae9c8c93172e3f.svg";
export { ForwardRef as ReactComponent };